import React, { useState, useEffect } from "react";
import { auth, provider, signInWithPopup } from "../../FirebaseConfig";
import { useLocation, useNavigate } from "react-router-dom";
import LoginImage from "../assets/Login.png";

function LoginSpace() {
  const [isChecked, setIsChecked] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  const location = useLocation();
  // Handle Google Sign-In
  const handleGoogleSignIn = async (e) => {
    e.preventDefault();
    if (!isChecked) {
      setShowPopup(true);
      return;
    }

    try {
      const result = await signInWithPopup(auth, provider);
      console.log("User Signed In:", result.user);
      const queryParams = new URLSearchParams(location.search);
    const redirectPath = queryParams.get("redirect") || "/";
    const productId = queryParams.get("productId");
    const quantity = queryParams.get("quantity");

    // Append productId and quantity if present
    const finalRedirect = productId && quantity
      ? `${redirectPath}?productId=${productId}&quantity=${quantity}`
      : redirectPath;

    navigate(finalRedirect);
    
      // navigate("/dashboard"); // Redirect after successful login
    } catch (error) {
      console.error("Sign-in error:", error);
    }
  };

  return (
    <div
      className="h-screen flex items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: `url(${LoginImage})` }}
    >
      <div className="bg-white/80 backdrop-blur-md p-8 rounded-xl shadow-lg w-full max-w-md text-center">
        <h2 className="text-2xl font-semibold text-gray-800">Welcome Back</h2>
        <p className="text-gray-600 mt-2">Sign in to continue</p>

        {/* Checkbox for Terms & Conditions */}
        <div className="mt-6 flex items-center space-x-2">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={() => setIsChecked(!isChecked)}
            className="h-4 w-4 text-orange-500 border-gray-300 rounded"
          />
          <label className="text-sm text-gray-600">
            By logging in, I agree to 
            <a href="/privacy-policy" target="_blank" className="text-orange-500 font-semibold ml-1 hover:underline">
              Terms & Conditions
            </a>
          </label>
        </div>

        {/* Google Sign-In Button */}
        <button
          onClick={handleGoogleSignIn}
          className="mt-6 flex items-center justify-center bg-white text-gray-700 border border-gray-300 px-6 py-2 rounded-lg shadow hover:shadow-md hover:bg-gray-100 transition w-full"
        >
          <img
            src="https://www.freepnglogos.com/uploads/google-logo-png/google-logo-png-suite-everything-you-need-know-about-google-newest-0.png"
            alt="Google Sign In"
            className="h-6 w-6 mr-2"
          />
          Sign in with Google
        </button>

        {/* Popup for Terms & Conditions */}
        {showPopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <h3 className="text-lg font-semibold">Please Agree to Terms & Conditions</h3>
              <p className="text-gray-600 mt-2">You must accept the terms before signing in.</p>
              <button
                onClick={() => setShowPopup(false)}
                className="mt-4 bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600 transition"
              >
                OK
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default LoginSpace;
